import { render, staticRenderFns } from "./AdmissionStatus.vue?vue&type=template&id=677a3699"
import script from "./AdmissionStatus.vue?vue&type=script&lang=js"
export * from "./AdmissionStatus.vue?vue&type=script&lang=js"
import style0 from "./AdmissionStatus.vue?vue&type=style&index=0&id=677a3699&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports